'use client'

import FabricCanvasTool from "../fabrictool"
import { fabric } from "@/@corefabriccanvas/fabric/dist/fabric"
import { SvgIcons } from "../../svgIcons"

class Marker extends FabricCanvasTool {

  
  configureCanvas(props) {
    this._canvas.isDrawingMode = true;
    this._canvas.freeDrawingBrush = new fabric.PencilBrush(this._canvas);

    // props.lineColor'u rgba formatına dönüştür
    const opacity = 0.4; // Opaklık değeri
    const [r, g, b] = this.hexToRgb(props.lineColor); // Hex rengi RGB'ye çevir
    this._canvas.freeDrawingBrush.color = `rgba(${r}, ${g}, ${b}, ${opacity})`;

    this._canvas.freeDrawingBrush.width = props.lineWidth;
    this._canvas.freeDrawingCursor = `url(${SvgIcons.getAsImageSrc(SvgIcons.Marker)}) ${2} ${24}, crosshair`;
  }

  // Hex rengini RGB formatına dönüştüren yardımcı fonksiyon
  hexToRgb(hex) {
    const normalizedHex = hex.replace(/^#/, '');
    const bigint = parseInt(normalizedHex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
  }
}

export default Marker;
